module.exports = __webpack_public_path__ + "alteration-icon.svg?a818470ac76647b108d8480523ab00fb";